import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { NotificationService } from "src/app/notifications/notification.service";
import { hexColor } from "src/app/shared/validators/hex-color-validator";
import { inArray } from "src/app/shared/validators/in-array.validator";
import { SignalsService } from "src/app/signals/signals.service";
import { UiService } from "src/app/ui/ui.service";
import { faPalette } from "@fortawesome/pro-light-svg-icons";
@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.scss"],
})
export class CategoryComponent implements OnInit {
  category: any;
  newCategory!: boolean;
  categoryGroup!: FormGroup;
  filteredIcons!: { name: string; icon: [IconPrefix, IconName] }[];
  onComponentDestroy = new Subject<void>();
  colorPickerColor: string = "";
  colorControl!: FormControl;
  currentIcon?: [IconPrefix, IconName];
  iconControl!: FormControl;
  faPalette = faPalette;
  constructor(
    private route: ActivatedRoute,
    private uiService: UiService,
    private signalService: SignalsService,
    private router: Router,
    private NotificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.category = this.route.snapshot.data.category;

    if (this.category) {
      const oldIconMap = this.uiService.oldFAIconsMap.find(
        (icon) => icon.name === this.category.icon,
      );
      if (oldIconMap) {
        this.category.icon = oldIconMap.newIconString;
      }
    }

    this.newCategory = !this.category;

    this.filteredIcons = this.uiService.faIcons;

    this.iconControl = new FormControl(this.category?.icon, [
      Validators.required,
      inArray(this.uiService.faIcons, "name"),
    ]);

    if (this.iconControl.valid) {
      this.currentIcon = this.iconControl.value.split(" ");
    }

    this.iconControl.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe(() => {
        if (this.iconControl.value === "") {
          this.filteredIcons = this.uiService.faIcons;
        }
        this.filteredIcons = this.uiService.faIcons.filter((icon) => {
          return (
            icon.name.includes(this.iconControl.value) ||
            icon.name.replace("-", " ").includes(this.iconControl.value)
          );
        });

        if (this.iconControl.valid) {
          this.currentIcon = this.iconControl.value.split(" ");
        }
      });

    (this.colorControl = new FormControl(this.category?.color, [
      Validators.required,
      hexColor(),
    ])),
      (this.categoryGroup = new FormGroup({
        nameControl: new FormControl(this.category?.name, [
          Validators.required,
        ]),
        iconControl: this.iconControl,
        colorControl: this.colorControl,
      }));
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get saveDisabled() {
    return this.categoryGroup.invalid;
  }

  get showPreview() {
    return this.colorControl.valid && this.iconControl.valid;
  }

  get signalCategoryDTO() {
    const categoryDTO: any = {
      name: this.categoryGroup.controls.nameControl.value,
      color: this.colorControl.value,
      icon: this.iconControl.value,
    };
    if (this.category) {
      categoryDTO.id = this.category.id;
    }
    return categoryDTO;
  }

  onColorPickerOK() {
    this.colorControl.setValue(this.colorPickerColor);
  }

  createCategory() {
    this.signalService
      .createSignalCategory(
        this.route.snapshot.params.accountID,
        this.signalCategoryDTO,
      )
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar("Category created");
          this.router.navigate([
            "accounts",
            this.route.snapshot.params.accountID,
          ]);
        },
        () => {
          this.NotificationService.openErrorSnackBar("Error creating category");
        },
      );
  }

  saveCategory() {
    this.signalService
      .updateSignalCategory(
        this.route.snapshot.params.accountID,
        this.signalCategoryDTO,
      )
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar("Category updated");
          this.router.navigate([
            "accounts",
            this.route.snapshot.params.accountID,
          ]);
        },
        () => {
          this.NotificationService.openErrorSnackBar("Error updating category");
        },
      );
  }
}
